"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOLSnappable = void 0;
const react_1 = require("react");
const OLSnapProvider_1 = require("./OLSnapProvider");
function useOLSnappable(isSnappable, feature) {
    const snappableFeatures = react_1.useContext(OLSnapProvider_1.OLSnappableCollectionContext);
    react_1.useEffect(() => {
        if (isSnappable) {
            snappableFeatures.push(feature);
            return () => {
                snappableFeatures.remove(feature);
            };
        }
        return () => { };
    }, [isSnappable, feature, snappableFeatures]);
}
exports.useOLSnappable = useOLSnappable;
//# sourceMappingURL=useOLSnappable.js.map